import Picker from 'emoji-picker-react'

function EmojiPicker({ showEmojiPicker, onEmojiClick }) {
  return (
    <div>
      {showEmojiPicker && (
        <Picker
          onEmojiClick={onEmojiClick}
          preload={true}
          disableAutoFocus={true}
          native={true}
        />
      )}
    </div>
  )
}

export default EmojiPicker
